<template>
	<div class="form">
		<h4 class="step-title">Who is your current insurer?</h4>
		<div class="step-content d-flex flex-column align-items-center step-button-list wider">
			<scrollable-button-list
				v-bind:items="insurers"
				v-bind:onclick="complete"
				v-bind:value="lead.autoInsurance.currentInsurer"
			/>
		</div>
	</div>
</template>

<script>
import ScrollableButtonList from "../shared/ScrollableButtonList.vue";

export default {
	name: "CurrentAutoInsurer",
	components: {
		ScrollableButtonList,
	},
	data: function () {
		return {
			insurers: [
				{ text: "Allstate", value: "Allstate" },
				{ text: "Farmers", value: "Farmers" },
				{ text: "Geico", value: "Geico" },
				{ text: "Liberty Mutual", value: "Liberty Mutual" },
				{ text: "Nationwide", value: "Nationwide" },
				{ text: "Progressive", value: "Progressive" },
				{ text: "State Farm", value: "State Farm" },
				{ text: "Travelers", value: "Travelers" },
				{ text: "USAA", value: "USAA" },
				{ text: "Other", value: "Other" },
			],
		};
	},
	props: {
		lead: Object,
	},
	methods: {
		complete: function (value) {
			this.lead.autoInsurance.currentInsurer = value;
			this.$emit("complete", this.$options.name, value);
		},
	},
};
</script>
